// import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } 	from 'gsap/ScrollSmoother';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, ScrollSmoother, Draggable, InertiaPlugin);
ScrollTrigger.config({ ignoreMobileResize: true});

import { debounce as _debounce, random as _random } from 'underscore';
//import '@benmajor/jquery-touch-events';


//let console = window.console;

export default class EFFEX{

    constructor(options) {

        this.defaults = {
        	debug: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

        this.namespace = 'effx';
		this.$window = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $('body');
		this.overshoot = 100;

		this.main = this.options.main;

		this.ids = [];

    }

	init(){

		this.addEvents( true );

		this.initCompactNav();
		setTimeout( ()=>this.initMobileNav(), 1000 );


		//setTimeout( ()=>this.initSingleCollectionHero(), this.$body.hasClass( 'collective-access' )? 1200:17 );

		//this.initSingleCollectionHero();
		this.initCollectionsStickyFilters();

		//console.log( 'initEffects' );
	}

	reset(){
		this.destroy();
		this.init()
	}

	//------------------------------------------ UTILS -----------------------------------------//
	addEvents( b ){
		if ( b ){
			this.r = _debounce( ()=>{ this.onResize() }, 200 );
			this.$window.on( 'resize', this.r );
		}
		else{
			if ( this.r ){
				this.r.cancel();
				this.$window.off( 'resize', this.r );
			}
		}
	}

	onResize(){
		//this.initSingleCollectionHero()
		//setTimeout( ()=>this.initSingleCollectionHero(), 200 );
	}

	getWindowHeight(){
		return this.$window.height();
	}
	getDocHeight(){
		return this.$doc.height();
	}

	//------------------------------------------ GA SCROLL EVENT ---------------------------------//
	/*
	initGAScrollEvent(){
		ScrollTrigger.create({
			trigger: $('main'),
			start: "center center",
			end: "center center",
			scroller: $(this.main.options.$scroll_el),
			//scrub: true,
			//markers: true,
			id: this.getID(),
			onEnter: self =>{
				//console.log( 'enter' )
				//this.$body.addClass( 'activate-nav-compact' )
				this.main.setGAEvent( 'Scroll Activity', 'Scroll Activity', 'center', self.direction );
			},
			onEnterBack: self =>{
				//console.log( 'enter back' )
				this.main.setGAEvent( 'Scroll Activity', 'Scroll Activity', 'center', self.direction );
			}
		}) 		
	}
	*/

	
	//------------------------------------------ EFFECTS -----------------------------------------//
	initCompactNav(){
		let $el = $('#compact-nav'), $trigger, start;

		if ( $el.length > 0 ){

			if ( $el.css('display') ===  'none'   ){
				return;
			}

			//$el.css( 'position', 'absolute' );

			$trigger 	= $( '#header' );

			start 		= "bottom top";
					
			ScrollTrigger.create({

				trigger: $trigger,
				start: start,

				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() + 200  },
				//toggleClass: "activate-nav-compact",
				
				scrub: true,
				markers: false,
				id: this.getID(),

				onEnter: ()=>{
					//console.log( 'enter' )
					this.$body.addClass( 'activate-compact-nav' ).addClass( 'show-compact-nav' );
				},
				onEnterBack: ()=>{
					//console.log( 'enter back' )
					this.$body.addClass( 'activate-compact-nav' ).addClass( 'show-compact-nav' );
				},
				onLeave: ()=>{
					this.$body.removeClass( 'activate-nav-compact' ).removeClass( 'show-compact-nav' );
					//console.log( 'leave' )
				},
				onLeaveBack: ()=>{
					//console.log( 'leave back' )
					this.$body.removeClass( 'activate-compact-nav' ).removeClass( 'show-compact-nav' );
				},
				onUpdate: self => {				
					let y = self.scroll(), direction = self.direction, progress = self.progress;
					
					/*
					if ( progress >= 0.8 ){
						this.$body.addClass( 'activate-nav-compact' ).addClass( 'show-compact-nav' );
						return;
					}
					*/
					
					/*
					//console.log( direction );
					if ( this.$body.hasClass( 'activate-compact-nav' ) ){
						// activate nav compact				
						if ( direction === 1 ){
							this.$body.removeClass( 'show-compact-nav' );
						}
						else if ( direction === -1 ){
							this.$body.addClass( 'show-compact-nav' );
						}
					}
					*/
				}
			})

		}
	}

	initMobileNav(){

		let $el = $('#mobile-header'), $trigger, start;

		if ( $el.length > 0 ){

			if ( $el.css('display') ===  'none'   ){
				return;
			}

			//$el.css( 'position', 'absolute' );

			$trigger 	= $el;

			start 		= "top top";
					
			ScrollTrigger.create({

				trigger: $trigger,
				start: start,
				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() + 200 },
				//toggleClass: "activate-nav-compact",
				
				scrub: true,
				markers: false,
				id: this.getID(),

				pin: true,
				pinSpacing: false,

				onEnter: ()=>{
					//console.log( 'enter' )
					this.$body.addClass( 'activate-mobile-compact-nav' );
					this.$body.addClass( 'show-mobile-compact-nav' );
				},
				onEnterBack: ()=>{
					//console.log( 'enter back' )
					//this.$body.addClass( 'activate-mobile-compact-nav' );
				},
				onLeave: ()=>{
					this.$body.removeClass( 'activate-mobile-nav-compact' )
					//console.log( 'leave' )
				},
				onLeaveBack: ()=>{
					//console.log( 'leave back' )
					//this.$body.removeClass( 'activate-mobile-compact-nav' );
				},
				onUpdate: self => {				
					let y = self.scroll(), direction = self.direction, progress = self.progress, top = 60 + ($('#top-bar').length>0?40:0);
					/*
					if ( progress >= 0.97 ){
						this.$body.addClass( 'hide-desktop-nav' ).removeClass( 'scroll-direction-back' );
						return;
					}
					*/
					//console.log( y + ', direction = ' + direction );


					if ( this.$body.hasClass( 'activate-mobile-compact-nav' ) ){
						// activate nav compact				
						if ( direction === 1 ){
							if ( y > top ){
								this.$body.removeClass( 'show-mobile-compact-nav' );
							}
						}
						else if ( direction === -1 ){
							this.$body.addClass( 'show-mobile-compact-nav' );
						}
					}
				}
			})

		}
	}


	//-------------------------------- SINGLE COLLECTION -------------------------------//
	initSingleCollectionHero(){
		let $el = $('.hero-single-collection'), $alert = $( '#top-bar' ), $header= $( '#header' ), $content = $('.content-wrap'), w = this.$window.width(), $layout, $container_scroll, $column_scroll, h, hlink, id, start, end, obj, triggers, top;

		return;

		if ( $el.length <= 0 ){
			return;
		}

		//console.log( 'initSingleCollectionHero' );

		if (w<1024){
			$header = $('#mobile-header');
		}

		// THIS IS FOR COLLECTIVE ACCESS
		if ( $content.length <= 0 ){
			$content = $('.container-fluid');
		}

		$layout = $el.find( '.layout' );
		$container_scroll 	= $layout.find('.item').eq(1).find( '.container-scroll' );
		$column_scroll		= $layout.find( '.size-column' );

		triggers = [$header, $content, $column_scroll];

		if ( $alert.length > 0 ){
			triggers.push( $alert );
		}
		// clear scrollTrigger
		this.clearScrolls( triggers );
 
		// reset some css
		$container_scroll.css({
			height: '100%'
		});
		$column_scroll.css({
			'padding-bottom' : 0
		});

		if (w >= 768 ){

			hlink 	= $layout.find( '.footer.link' ).length > 0 ? $layout.find( '.footer.link' ).outerHeight() : 0;
			h 		= $layout.find('.item').outerHeight() - hlink;

			//console.log( $layout.find('.item').outerHeight() + ',' + hlink );

			/*
			if ( $layout.find( '.shadow' ).length  ){
				h  -=  $layout.find( '.shadow' ).height();
			}
			*/


			$container_scroll.height( h );

			if ( $column_scroll.height() <= h ){

				$layout.find( '.shadow' ).css({
					display: 'none'
				});

				return;

			}
			else {

				//
				history.scrollRestoration = "manual";
				this.$window.scrollTop(0);

				// set the scroll to 0 to avoid strange results
				//gsap.to(this.$window, {duration: 0, scrollTo: 0});


				// add the padding of the footer link
				
				$column_scroll.css({
					'padding-bottom' : hlink
				});

				// Length of the col to scroll
				end  = $column_scroll.outerHeight() - h;

				top = 0;

				if ( $alert.length > 0 ){

	    			//1 )_ PIN ALERT
					// assign id !
					id = this.assignID( $alert );
					start = 'top top';

	    			ScrollTrigger.create({
						trigger: $alert,
						start: start,
						end: end,
						pinSpacing: false,
						pinReparent: false,
						scrub: false,
						markers: false,
						pin: true,
						id: id,
	    			});

	    			top = $alert.height();
				}

    			//1 )_ PIN HEADER
				// assign id !
				id = this.assignID( $header );
				start = 'top top+=' + top + 'px';

    			ScrollTrigger.create({
					trigger: $header,
					start: start,
					end: end,
					pinSpacing: false,
					pinReparent: false,
					scrub: false,
					markers: false,
					pin: true,
					id: id,
    			});

    			if ( w >= 1024 ){
    				
	    			$header.parents( '.pin-spacer' ).css({
	    				'background-color': $el.css('background-color')
	    			});
	    			
    			}
				

    			//2 )_ PIN ALL THE CONTENT BELOW HEADER
				id = this.assignID( $content );
				start = "top top+=" + ( top + $header.height() ) + 'px';

    			ScrollTrigger.create({
					trigger: $content,
					start: start,
					end: end,
					scrub: true,
					markers: false,
					pin: true,
					id: id,
    			});

    			if ( w >= 1024 ){

    				/*
	    			$el.parents( '.pin-spacer' ).css({
	    				'background-color': $el.css('background-color')
	    			})
	    			*/
    			}

    			//3) SCROLL COL
				id = this.assignID( $column_scroll );
				//start = "top top+=" + $header.height() + 'px';

    			obj =  {
					y: - end,
					//ease: "power.easeOut",
					scrollTrigger: {
						trigger: $el, // IMPORTANT : the trigger is the inner containe ( or could be $col1 )
						start: start,
						end: "+=" + end,
						scrub: true,
						markers: false,
						id: id,
					} 
				}
				
				gsap.to( $column_scroll, obj );

				
			}
		}
	}

	/*
	initSingleCollectionHeroBackup(){
		let $el = $('.hero-single-collection'), $alert = $( '#top-bar' ), $header= $( '#header' ), w = this.$window.width(), $layout, $container_scroll, $column_scroll, h, hlink, id, start, end, obj, triggers, top;

		if ( $el.length <= 0 ){
			return;
		}

		//return;

		if (w<1024){
			$header = $('#mobile-header');
		}


		$layout = $el.find( '.layout' );
		$container_scroll 	= $layout.find('.item').eq(1).find( '.container-scroll' );
		$column_scroll		= $layout.find( '.size-column' );

		triggers = [$header, $el, $column_scroll];

		if ( $alert.length > 0 ){
			triggers.push( $alert );
		}
		// clear scrollTrigger
		this.clearScrolls( triggers );
 
		// reset some css
		$container_scroll.css({
			height: '100%'
		});
		$column_scroll.css({
			'padding-bottom' : 0
		});

		if (w >= 768 ){

			hlink 	= $layout.find( '.link' ).length > 0 ? $layout.find( '.link' ).outerHeight() : 0;
			h 		= $layout.find('.item').height() - hlink;

			if ( $layout.find( '.shadow' ).length  ){
				h  -=  $layout.find( '.shadow' ).height();
			}

			$container_scroll.height( h );

			if ( $column_scroll.height() > h ){

				// add the padding of the footer link
				$column_scroll.css({
					'padding-bottom' : hlink
				});


				// Length of the col to scroll
				end  = $column_scroll.outerHeight() - h;

				top = 0;

				if ( $alert.length > 0 ){

	    			//1 )_ PIN ALERT
					// assign id !
					id = this.assignID( $alert );
					start = 'top top';

	    			ScrollTrigger.create({
						trigger: $alert,
						start: start,
						end: end,
						pinSpacing: false,
						pinReparent: false,
						scrub: false,
						markers: false,
						pin: true,
						id: id,
	    			});

	    			top = $alert.height();
				}

    			//1 )_ PIN HEADER
				// assign id !
				id = this.assignID( $header );
				start = 'top top+=' + top + 'px';

    			ScrollTrigger.create({
					trigger: $header,
					start: start,
					end: end,
					pinSpacing: false,
					pinReparent: false,
					scrub: false,
					markers: false,
					pin: true,
					id: id,
    			});

    			if ( w >= 1024 ){
    				
	    			$header.parents( '.pin-spacer' ).css({
	    				'background-color': $el.css('background-color')
	    			});
	    			
    			}
				

    			//2 )_ PIN HERO COLLECTION BELOW HEADER
				id = this.assignID( $el );
				start = "top top+=" + ( top + $header.height() ) + 'px';

    			ScrollTrigger.create({
					trigger: $el,
					start: start,
					end: end,
					scrub: true,
					markers: false,
					pin: true,
					id: id,
    			});

    			if ( w >= 1024 ){

    				
	    			$el.parents( '.pin-spacer' ).css({
	    				'background-color': $el.css('background-color')
	    			})
	    			
    			}

    			//3) SCROLL COL
				id = this.assignID( $column_scroll );
				//start = "top top+=" + $header.height() + 'px';

    			obj =  {
					y: - end,
					//ease: "power.easeOut",
					scrollTrigger: {
						trigger: $el, // IMPORTANT : the trigger is the inner containe ( or could be $col1 )
						start: start,
						end: "+=" + end,
						scrub: true,
						markers: false,
						id: id,
					} 
				}
				
				gsap.to( $column_scroll, obj );

				
			}
			else{
				
				//console.log( 'NO effect!' )
			}
		}
	}
	*/
	
	initCollectionsStickyFilters(){
		let $el = $('.page-template-collections .stiky-filters'), $header = $('#compact-nav'), start;

		if ( $el.length > 0 ){


			if ( $header.css('display') ===  'none'   ){
				return;
			}

			start 		= "top top+=" + $header.height();
					
			ScrollTrigger.create({

				trigger: $el,
				start: start,

				end: ()=>{ return this.getDocHeight() - this.getWindowHeight() },
				//toggleClass: "activate-nav-compact",
				pin: true,
				scrub: true,
				markers: false,
				id: this.getID(),
				pinSpacing: false

				/*
				onEnter: ()=>{
					//console.log( 'enter' )
					this.$body.addClass( 'activate-compact-nav' ).addClass( 'show-compact-nav' );
				},
				onEnterBack: ()=>{
					//console.log( 'enter back' )
					this.$body.addClass( 'activate-compact-nav' ).addClass( 'show-compact-nav' );
				},
				onLeave: ()=>{
					this.$body.removeClass( 'activate-nav-compact' ).removeClass( 'show-compact-nav' );
					//console.log( 'leave' )
				},
				onLeaveBack: ()=>{
					//console.log( 'leave back' )
					this.$body.removeClass( 'activate-compact-nav' ).removeClass( 'show-compact-nav' );
				},
				*/

				/*
				onUpdate: self => {				
					let y = self.scroll(), direction = self.direction, progress = self.progress;
					
				
					if ( progress >= 0.8 ){
						this.$body.addClass( 'activate-nav-compact' ).addClass( 'show-compact-nav' );
						return;
					}
					
					
					
					//console.log( direction );
					if ( this.$body.hasClass( 'activate-compact-nav' ) ){
						// activate nav compact				
						if ( direction === 1 ){
							this.$body.removeClass( 'show-compact-nav' );
						}
						else if ( direction === -1 ){
							this.$body.addClass( 'show-compact-nav' );
						}
					}
				
				}
				*/

			})

		}
	}

	//-------------------------------------------- UTILS ------------------------------//
	clearScrolls( arr ){
		let i = arr.length, $el, id;
		while( i-- ){
			$el = arr[ i ];
			id = $el.attr( 'scroll_id' );
			if ( id ){
				this.killById( id );
				gsap.killTweensOf( $el );
				gsap.set( $el, {clearProps: 'all' });
				$el.attr( 'scroll_id', false );
			}
		}
	}

	assignID( $el ){
		const id = this.getID();
		$el.attr( 'scroll_id', id );
		return id;
	}

	getID(){
		const id = 'id_' + this.ids.length;
		this.ids.push( id );
		return id;
	}

	killById( id ){
		if ( ScrollTrigger.getById( id ) ){
			ScrollTrigger.getById( id ).kill();
		}
	}

	destroy(){
      	this.addEvents( false );
      	if ( this.ids.length ){
      		let i = this.ids.length;
      		while( i-- ){
      			this.killById( this.ids[i] );
      		}
      		this.ids = [];
      	}
	}
			
}



